import React, { Component } from 'react'

export default class BusinessTag extends Component {
    componentDidMount() {
        jQuery(jQuery("input[type='text'].null")[0]).focus();
    }
    constructor(props) {
        super(props);
        this.state = {
            width: (this.props.label.length === 0? 80 : (this.props.label.length) * 8) + 10
        }
    }

    handleChange(event) {
        this.props.update(event);
        this.setState({ ...this.state, width: (event.target.value.length === 0? 80 : event.target.value.length * 8) + 10 });
    }

    render() {
        return (
            <span className='badge badge-pill badge-secondary biz-tag mr-2 mb-2'>
                <input type="text" value={this.props.label} placeholder={__('Enter label...')}
                    name={"label_"+(this.props.tag.id??"new_"+this.props.uuid)}
                    onChange={this.handleChange.bind(this)}
                    className={"" + this.props.tag.id}
                    style={{width: this.state.width + "px"}}
                />
                <span onClick={this.props.delete} className='feedback-tag-remove'><i className='fas fa-times ml-2'/></span>
            </span>
        )
    }
}
